import { IMeasuringPoint, IMeasuringPointNavigator } from "@ramudden/models/measuring-point";
import { ILocationSummary, IMeasuringPointSummary } from "@ramudden/models/web";

export class MeasuringPointUtils {
    static toNavigator(measuringPoint: IMeasuringPoint | IMeasuringPointSummary): IMeasuringPointNavigator {
        if (!measuringPoint) return null;

        return {
            id: measuringPoint.id,
            locationId: (measuringPoint as IMeasuringPoint).location
                ? (measuringPoint as IMeasuringPoint).location.id
                : (measuringPoint as IMeasuringPointSummary).locationId || null,
            code: measuringPoint.code,
            isObsolete: false,
        } as IMeasuringPointNavigator;
    }

    static toSummary(measuringPoint: IMeasuringPoint): IMeasuringPointSummary {
        if (!measuringPoint) return null;

        const result = {
            id: measuringPoint.id,
            code: measuringPoint.code,
            locationId: measuringPoint.locationId,
            description: measuringPoint.description,
            analysisTypeId: measuringPoint.analysisTypeId,
            ownerId: measuringPoint.ownerId,
        } as unknown as IMeasuringPointSummary;

        if (measuringPoint.location) {
            result.location = {
                id: measuringPoint.location.id,
                code: measuringPoint.location.code,
                iconStateId: measuringPoint.location.mapIconStateId ?? 0,
                lat: measuringPoint.location.coordinate.latitude,
                lng: measuringPoint.location.coordinate.longitude,
                ownerId: measuringPoint.location.ownerId,
            } as ILocationSummary;
        }
        return result;
    }
}
